export default {
  BuPlanReceiptBudget: 152, // 'Dự toán thu đầu năm theo MLNS',
  BuPlanReceiptBudgetAdd: 153, // 'Dự toán thu bổ sung theo MLNS',
  BuPlanReceiptBudgetSupplement: 321, // 'Dự toán thu điều chỉnh theo MLNS',
  BuPlanReceiptActivity343: 334, // 'Dự toán thu đầu năm theo NDKT (Mẫu TT 343/2016/TT-BTC)',
  BuPlanReceiptActivityAdd343: 335, // 'Dự toán thu bổ sung theo NDKT (Mẫu TT 343/2016/TT-BTC)',
  BuPlanReceiptActivitySupplement343: 336, // 'Dự toán thu điều chỉnh theo NDKT (Mẫu TT 343/2016/TT-BTC)',
  BuPlanReceiptActivity344: 337, // 'Dự toán thu đầu năm theo NDKT (Mẫu TT 344/2016/TT-BTC)',
  BuPlanReceiptActivityAdd344: 338, // 'Dự toán thu bổ sung theo NDKT (Mẫu TT 344/2016/TT-BTC)',
  BuPlanReceiptActivitySupplement344: 339, // 'Dự toán thu điều chỉnh theo NDKT (Mẫu TT 344/2016/TT-BTC)',
  BuPlanReceiptActivity342: 331, // 'Dự toán thu đầu năm theo NDKT (Mẫu TT 342/2016/TT-BTC)',
  BuPlanReceiptActivityAdd342: 332, // 'Dự toán thu bổ sung theo NDKT (Mẫu TT 342/2016/TT-BTC)',
  BuPlanReceiptActivitySupplement342: 333, // 'Dự toán thu điều chỉnh theo NDKT (Mẫu TT 342/2016/TT-BTC)',
};
